import type { IconProps } from 'components/Icon';

import styles from './MetaDataBar.module.css';

import { Icon } from 'components/Icon';

export type itemType = {
  iconName: IconProps['name'];
  itemLabel: string;
};

export interface MetaDataBarProps {
  /** A array of itemType object's to display in the bar. itemType { iconName: IconProps['name']; itemLabel: string; } */
  itemData: itemType[];
}

/** Represents a component that displays a array of data in a bar. */
export const MetaDataBar = ({ itemData }: MetaDataBarProps) => {
  return (
    <div className={styles['meta-data-bar']}>
      {itemData.map(({ iconName, itemLabel }) => {
        return (
          itemLabel.indexOf('undefined') === -1 && (
            <div className={styles['meta-data-bar__item']} key={itemLabel}>
              <Icon name={iconName} size={16} />
              <span className={styles['meta-data-bar__item-label']}>{itemLabel}</span>
            </div>
          )
        );
      })}
    </div>
  );
};
